<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    <v-btn @click="$router.go(-1)" outlined style="border: none;margin-right: 10px" title="Retourner à la liste des mails"><v-icon>mdi mdi-arrow-left</v-icon></v-btn>

                    {{$t('newsletters.newsletters_management')}}
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card v-if="submitting" style="margin-left: 38%;margin-top: 20%" >
                    <img src="/loaders/loader_turq.gif" alt=""><br>
                    <span class="loader_text"> Envoie en cours ... </span>
                </v-card>
                <v-card v-if="!submitting">
                    <v-card-text>
                        <v-alert v-if="errors.operation" dense outlined type="error">
                            {{errors.operation}}
                        </v-alert>

                        <v-form ref="form" v-model="valid" :lazy-validation="lazy"  enctype="multipart/form-data">
                            <v-row>
                                <v-col class="d-flex" cols="12" sm="12">
                                    <v-select
                                            :items="items"
                                            :rules="labelRules" v-model="editedItem._type" :label="$t('newsletters.type')"
                                    ></v-select>
                                </v-col>
                                <v-container fluid>
                                    <v-row align="center">

                                        <v-col v-if="editedItem._type==='Spécifique'" cols="12" sm="12"
                                               md="12">
                                            <v-autocomplete
                                                    :items="drop_down_user"
                                                    attach
                                                    chips
                                                    label="Utilisateurs"
                                                    v-model="editedItem._users"
                                                    item-value="_email"
                                                    dense
                                                    hint="Selectionner les utilisateurs concernés"
                                                    multiple


                                            >

                                            </v-autocomplete>

                                        </v-col>
                                    </v-row>
                                </v-container>
                                <v-col cols="12" md="12">
                                    <v-text-field v-model="editedItem._subjet"  :rules="fileRules_sujet"    label="Subjet"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <v-file-input v-model="editedItem._joint"    label="Pièce joint"></v-file-input>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <v-col cols="12" sm="6" md="12">
                                        <editor
                                                ref="editor"
                                                :rules="messageRules"
                                                v-model="editedItem._message"
                                                api-key="fblqzk357gvk5kptdbgmtedjh9j8m9mgf6sjewjszc75gyk7"
                                                :init="{height: 300,menubar: false,plugins: ['advlist autolink lists link image charmap print preview anchor','searchreplace visualblocks code fullscreen','insertdatetime media table paste code help wordcount'   ],       toolbar:'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help'
       }"
                                        />
                                    </v-col>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="dark"  @click.prevent="close">{{$t('cancel')}}</v-btn>
                        <v-btn  class="primary" :disabled="!editedItem._message || mis  "   @click.prevent="brouillon">Brouillon</v-btn>

                        <v-btn v-if="editedItem._type==='Spécifique'"  class="primary" :disabled="!editedItem._message || ! editedItem._users || !editedItem._type  || mis || !editedItem._subjet"  @click.prevent="save">{{$t('send')}}</v-btn>
                        <v-btn v-else class="primary" :disabled="!editedItem._message ||  !editedItem._type || mis || !editedItem._subjet"  @click.prevent="save">{{$t('send')}}</v-btn>
                    </v-card-actions>

                </v-card>

            </v-card>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import Editor from '@tinymce/tinymce-vue'
    import helpers from "../../../../mixins/helpers";


    export default {
        name: "Newsletters",
        mixins:[helpers(this)],
        data () {
            return {
                e6: [],
                e7: [],
                items: ['Tous les marchands', 'Tous les utilisateurs','Abonnés', 'Spécifique'],
                submitting:false,
                valid:true,
                mis:false,
                lazy:false,
                errors:{},
                customSnack:{
                    snackbar: false,
                    text: "",
                    snackcolor:"black",
                    snackbBtnColor:"white",
                    snacktimeout:2000
                },
                search: '',
                dialog: '',
                id:undefined,
                headers: [
                    {text: this.$t('newsletters.type'), value: '_code'},
                    {
                        text: this.$t('newsletters.message'),
                        align: 'start',
                        sortable: false,
                        value: '_description',
                    },
                    {text: this.$t('date'), value: '_created_at'},
                    { text: this.$t('action'), value: 'actions', sortable: false },

                ],
                editedIndex: -1,
                editedItem: {
                    _message: '',
                    _type: '',
                    _users: '',
                    _joint: '',
                    _created_at: 0,
                    _id:''
                },
                defaultItem: {
                    _message: '',
                    _type: '',
                    _users: '',
                    _joint: '',
                    _created_at: 0,
                    _id:''
                },
                labelRules: [
                    v => !!v || this.$t('newsletters.type_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                messageRules: [
                    v => !!v || this.$t('newsletters.message_required'),
                ],
                fileRules: [
                    v => !!v || this.$t('file_required'),
                ]
                ,fileRules_sujet: [
                    v => !!v || 'Le sujet est réquis',
                ],
            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? this.$t('newsletters.new') : this.$t('newsletters.update')
            },
            ...mapState('users/',['users']),
            ...mapState('newsletters/',['newsletters']),
            ...mapState('newsletters/',['newsletter']),
            drop_down_user: function(){
                let arr = [];
                this.users.forEach((users)=>{
                    arr.push({text:users._email,value:users._id})
                });
                return arr;
            },
        },
        mounted(){
            this.$store.dispatch('newsletters/get').then(response=>{
                window.console.log('newsletters',response)
            });
            if (this.$route.params.id) {
                this.$store.dispatch('newsletters/getOne',this.$route.params.id).then(response=>{
                    window.console.log('newsletter',response)
                });
            }

            if (this.newsletter){
               this.editedItem=this.newsletter;
            }

            this.$store.dispatch('users/getUsers').then(response=>{
                window.console.log('user',response)

            });


        },
        components: {
            'editor': Editor
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            initialize () {
                this.langues = [
                    {
                        name:'Bénin',
                        code_iso_alpha_2:'BJ',
                        code_iso_alpha_3:'BEN',
                        code_iso_numerique:204
                    }
                ]
            },
            editItem (item) {
                this.editedIndex = this.category_marchands.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
                this.id = item._id;
            },

            deleteItem (item) {
                let VueBox=this;
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    confirmButtonColor:'#191970',
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.submitting = true;
                        this.$store.dispatch('category_marchands/deleteCategorie_Marchand', item._id).then((result) => {
                            this.submitting = false ;
                            if (!result.error){
                                VueBox.toast('success',this.$t(result.message));
                            }
                        })
                    }
                })
            },

            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
            },

            save () {
                let VueBox=this;
                let data = new FormData();
                this.mis=true;
                data.append("subjet",(this.editedItem._subjet));
                data.append("message",(this.editedItem._message));
                data.append("type",this.editedItem._type);
                data.append("users",JSON.stringify(this.editedItem._users));
                data.append("file", this.editedItem._joint);
                if (this.id)
                    data.append("id",this.id);
                this.submitting = true;
                this.$store.dispatch('newsletters/set',data).then((response)=>{
                    console.log('set newsletters response',response);
                    if (response.error){
                        this.submitting = false;
                        VueBox.toast('error',this.$t(response.message));
                    }else{
                        this.submitting = false;
                        this.close();
                        this.$router.push({ path: '/listes/newsletters' })
                    }
                })
            },
            brouillon () {
                let VueBox=this;
                let data = new FormData();
                this.mis=true;
                data.append("subjet",(this.editedItem._subjet));
                data.append("message",(this.editedItem._message));
                data.append("type",this.editedItem._type);
                data.append("users",JSON.stringify(this.editedItem._users));
                data.append("file", this.editedItem._joint);
                data.append("brouillon",'brouillon');
                if (this.id)
                    data.append("id",this.id);
                this.submitting = true;
                this.$store.dispatch('newsletters/set',data).then((response)=>{
                    console.log('set newsletters response',response);
                    if (response.error){
                        this.submitting = false;
                        VueBox.toast('error',this.$t(response.message));
                    }else{
                        this.submitting = false;
                        this.close();
                        this.$router.push({ path: '/listes/newsletters' })
                    }
                })
            },
            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            fileChange() {
                console.log( this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },
    }
</script>

<style scoped>

</style>
